import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import {
  errorToast,
  formatDate,
  formateExportName,
  getLocalStorageService,
  lowerCase,
  setLocalStorageService,
  utcDate,
} from "@/core/helpers/utility";
import { tableExport } from "@/core/helpers/utility";
export const useEntityStore = defineStore("entity", {
  state: () => ({
    errors: {},
    entityDetails: getLocalStorageService("entityDetails"),
    localEntity: getLocalStorageService("sub-entity"),
    localEntityDetails: getLocalStorageService("entityDetails"),

    cashflow: null,
    cashflowSummary: null,
    topStationCashflow: null,

    stationSales: null,
    topBranchSales: null,
    topRegionSales: null,

    productStock: {
      summary: [],
      reports: [],
    },

    productDischarged: null,
    productDischargedSummary: null,

    stockValuation: {
      reports: null,
      summary: null,
    },
  }),
  getters: {},
  actions: {
    //reset store
    resetStore() {
      this.$reset();
    },
    setUserCompany(company) {
      this.errors = {};
      ApiService.setAuthorizationHeader();
      this.setCompany(company);
    },
    setError(error) {
      this.errors = { ...error };
    },

    //REPORTS
    //cashflow
    async _getCashflow({
      dateRange = {},
      query = {},
      entity = {},
      isExport,
      exportType,
    } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { startDate = "", endDate = "" } = dateRange ?? {};
      const { page = 1, search = "", rowsPerPage = 10 } = query ?? {};

      const params = {
        id: entityId,
        entityType,
        startDate,
        endDate,
        query: search,
        page,
        pageLimit: rowsPerPage,
        range: 5,
        export: exportType,
      };

      return ApiService.get(`/v2/Entity/Cashflow/Report`, {
        params,
        fileType: exportType,
      }).then((response) => {
        if (isExport) {
          // Call tableExport function
          tableExport(
            formateExportName("cashflow"),
            exportType === "excel" ? "xlsx" : exportType,
            response.data
          );
        } else {
          this.cashflow = response.data;
          return response;
        }
      });
    },

    //cashflow summary
    async _getCashflowSummary({ dateRange = {}, entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { startDate = "", endDate = "" } = dateRange ?? {};

      const params = {
        id: entityId,
        entityType,
        startDate,
        endDate,
      };

      return ApiService.get(`/v2/Entity/Cashflow/Report/Summary`, {
        params,
      }).then((response) => {
        this.cashflowSummary = response?.data?.data;
        return response;
      });
    },

    async _getTopStationCashflow({ date = "", entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
      };

      return ApiService.get(`/v2/Entity/TopStationCashflow`, { params }).then(
        (response) => {
          this.topStationCashflow = response.data.data?.slice(0, 10);
          return response;
        }
      );
    },

    //station sales
    async _getStationSalesSummary({ dateRange = {}, entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { startDate = "", endDate = "" } = dateRange ?? {};

      const params = {
        id: entityId,
        entityType,
        startDate,
        endDate,
      };

      return ApiService.get(`/v2/Entity/BranchSales/Summary`, { params }).then(
        (response) => {
          return response;
        }
      );
    },

    async _getTopBranchSales({ date = "", entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
      };

      return ApiService.get(`/v2/Entity/TopBranchSales`, { params }).then(
        (response) => {
          this.topBranchSales = response.data.data?.slice(0, 10);
          return response;
        }
      );
    },

    async _getTopRegionSales({ date = "", entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
      };

      return ApiService.get(`/v2/Entity/TopRegionSales`, { params }).then(
        (response) => {
          this.topRegionSales = response.data.data?.slice(0, 10);
          return response;
        }
      );
    },

    async _getStationSales({
      dateRange = {},
      query = {},
      entity = {},
      isExport,
      exportType,
      totalData,
    } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { startDate = "", endDate = "" } = dateRange ?? {};
      const { page = 1, search = "", rowsPerPage = 10 } = query ?? {};

      const params = {
        id: entityId,
        entityType,
        startDate,
        endDate,
        query: search,
        page,
        pageLimit: isExport ? totalData : rowsPerPage,
        range: 5,
        export: exportType,
      };

      return ApiService.get(`/v2/Entity/BranchSales`, {
        params,
        fileType: exportType,
      }).then((response) => {
        if (isExport) {
          tableExport(
            formateExportName("station_sales"),
            exportType === "excel" ? "xlsx" : exportType,
            response.data
          );
        } else {
          return response;
        }
      });
    },

    //product stock report

    async _getProductStockSummary({ date, entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
      };

      return ApiService.get(`/v2/Entity/TankStock/summary`, { params }).then(
        (response) => {
          this.productStock.summary = response.data.data;
          return response;
        }
      );
    },

    async _getProductStock({
      date,
      query = {},
      entity = {},
      isExport,
      exportType,
    } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { startDate = "", endDate = "" } = date ?? {};
      const { page = 1, search = "", rowsPerPage = 10 } = query ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
        query: search,
        page,
        pageLimit: rowsPerPage,
        range: 5,
        export: exportType,
      };

      return ApiService.get(`/v2/Entity/TankStock/`, {
        params,
        fileType: exportType,
      }).then((response) => {
        const result = response.data;
        const reports = response.data.data;
        if (isExport) {
          tableExport(
            formateExportName("product_stock_report"),
            exportType === "excel" ? "xlsx" : exportType,
            result
          );
        } else {
          reports.forEach((report) => {
            report.branchRegion = report.branchRegion ?? "N/A";
          });
          result.data = reports;
          this.productStock.reports = result;
          return response;
        }
      });
    },

    // product discharged

    async _getProductDischargedSummary({ date = "", entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
      };

      return ApiService.get(`/v2/Entity/TanksFilled/Summary`, { params }).then(
        (response) => {
          this.productDischargedSummary = response.data.data;
          return response;
        }
      );
    },

    async _getProductDischarged({ query = {}, entity = {}, date = "" } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};
      const { page = 1, search = "", rowsPerPage = 10 } = query ?? {};

      const params = {
        id: entityId,
        entityType,
        date,
        query: search,
        page,
        pageLimit: rowsPerPage,
        range: 5,
      };

      return ApiService.get(`/v2/Entity/TanksFilled`, { params }).then(
        (response) => {
          this.productDischarged = response.data;
          return response;
        }
      );
    },

    //stock valuaation
    async _getStockValuation({ query = {}, entity = {} }) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const { page = 1, search = "", rowsPerPage = 10 } = query ?? {};
      const params = {
        id: entityId,
        entityType,
        query: search,
        page,
        pageLimit: rowsPerPage,
        range: 5,
      };

      return ApiService.get(`/v2/Entity/StockValuation/Report`, {
        params,
      }).then((response) => {
        this.stockValuation.reports = response.data;
        return response;
      });
    },

    async _getStockValuationSummary({ entity = {} } = {}) {
      const { entityId = "", entityType = "" } = entity ?? {};

      const params = {
        id: entityId,
        entityType,
      };

      return ApiService.get(`/v2/Entity/StockValuation/Report/Summary`, {
        params,
      }).then((response) => {
        this.stockValuation.summary = response.data.data;
        return response;
      });
    },

    async _getEntityData(params) {
      const { entityId, entityType } = params ?? {};
      return await ApiService.get(
        `/v2/Entity/MyEntity/${entityId}/${entityType}`
      )
        .then((response) => {
          const result = response.data.data[0];

          this.entityDetails = result;

          entityType?.toLowerCase() === "company" && this.setEntity(result);
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    async getEntity() {
      return await ApiService.get(`v2/Entity/MyEntity`)
        .then((response) => {
          const result = response.data.data[0];

          this.entityDetails = result;
          this.setEntity(result);
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    async getEntityStations(params) {
      const { entityId, entityType, pageLimit = 10 } = params;
      // ?id=${entityId}&type=${entityType}&pageLimit=${pageLimit}
      return await ApiService.get(`/v2/Entity/Branches`, {
        params: {
          ...params,
        },
      })
        .then((response) => {
          // const result = response.data.data[0];

          // this.entityDetails = result;
          // this.setEntity(result);
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    setEntity(entity) {
      if (!entity) return errorToast("No entity");
      const { id, entityType } = entity ?? {};
      const entityId = `${lowerCase(entityType)}-id`;
      setLocalStorageService(entityId, id);

      setLocalStorageService("entityDetails", entity);
      setLocalStorageService("entityType", entityType);
    },
    getSubEntity() {
      this.localEntity = getLocalStorageService("sub-entity");
    },
    getEntityDetails() {
      this.localEntityDetails = getLocalStorageService("entityDetails");
    },
  },
});
